<template>
  <v-container v-if="slugs && slugs.length" :class="['px-4', 'page-header', 'pb-0']">
    <div :class="['px-2']">
      <h1 :class="['font-weight-light', 'title', 'pb-3', 'text-uppercase']">
        <template v-for="(slug, index) in slugs">
          <router-link :to="makeSlug(index)" :class="['white--text']" :key="index" :title="toTitleCase(slug)" v-html="fixTitle(slug)" /><span :key="`${index}-separator`" v-if="index < slugs.length - 1">&nbsp;&raquo;&nbsp;</span>
        </template>
      </h1>
      <v-divider />
    </div>
  </v-container>
</template>
<script>
import toTitleCase from 'to-title-case'

export default {
  name: 'PageHeader',
  data () {
    return {
      slugs: [],
      toTitleCase
    }
  },
  watch: {
    $route () {
      this.makeHeaderText()
    }
  },
  mounted () {
    this.makeHeaderText()
  },
  methods: {
    makeSlug (index) {
      return [''].concat(this.slugs.slice(0, index + 1)).join('/')
    },
    fixTitle (slug) {
      slug = this.$lang.titleFixes[slug] || slug
      return toTitleCase(slug)
    },
    makeHeaderText () {
      const appName = this.$config.appName
      let slugs = this.$route.path.split('/').filter(param => param !== '')
      let title = slugs.concat([appName]).join(' | ')
      this.slugs = slugs.filter(slug => isNaN(slug))
      title = title.replace(/-/g, ' ')
      document.title = toTitleCase(title)
        .replaceAll('the', 'The')
        .replace(/mmxxi/i, 'MMXXI')
        .replace('a ', 'A ')
        .replace('J S A', 'J/S:')
        .replace(/Theophag St/i, appName)
    }
  }
}
</script>
<style>
.page-header a
{
  text-decoration: none;
}

.page-header a:hover
{
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/page-header.vue